// External Libs
import React, { Component } from 'react';

// Internal Libs
import Modal from '../../../components/modal/modal';

class WireSelectionManualUpload extends Component {
  render() {
    return (
      <Modal
        preset="upload-pdf"
        header_text={this.props.header_text}
        modal_size_class="modal-lg"
        case_id={this.props.case_id}
        folder="ws"
        type={this.props.type}
        onUpload={(data) => {
          this.props.onUpload(data);
        }}
        location={this.props.location}
        upload_content={[]}
        onCloseButtonClick={() => {
          this.props.onClose();
        }}
        theme="bpp"
        wire_name={this.props.wire_name}
        prev_ws_manual_file_name={this.props.prev_ws_manual_file_name}
        replace={this.props.replace}
        wsg_rev={this.props.wsg_rev}
        wsg_manual_id={this.props.wsg_manual_id}
        ws_version={this.props.ws_version}
      />
    );
  }
}

export default WireSelectionManualUpload;
